import { useState, useEffect } from 'react'

function TestimonialCard({ testimonial, isActive }) {
  return (
    <div
      className={`transition-all duration-500 ${
        isActive ? 'opacity-100 scale-100' : 'opacity-0 scale-95 absolute inset-0'
      }`}
    >
      <div className="bg-white rounded-2xl border border-neutral-200 p-8 md:p-12 shadow-sm">
        <div className="flex items-start gap-2 mb-6">
          {[1, 2, 3, 4, 5].map((star) => (
            <svg
              key={star}
              className="w-5 h-5 text-amber-400 fill-current"
              viewBox="0 0 20 20"
            >
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          ))}
        </div>

        <blockquote className="text-lg md:text-xl text-neutral-700 leading-relaxed mb-6">
          "{testimonial.quote}"
        </blockquote>

        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary-100 to-primary-200 flex items-center justify-center text-primary-700 font-semibold text-lg">
            {testimonial.name.charAt(0)}
          </div>
          <div>
            <div className="font-semibold text-neutral-900">{testimonial.name}</div>
            <div className="text-sm text-neutral-600">{testimonial.role}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0)

  const testimonials = [
    {
      id: 1,
      quote: "Beaver made buying off-plan so much less stressful. I could track everything in one place, understand the process, and never felt pressured. The discount calculator helped me make a smart decision about my first home.",
      name: "Sarah Mitchell",
      role: "First Home Buyer, Auckland",
    },
    {
      id: 2,
      quote: "As an investor, I needed clear numbers. Beaver's yield calculator and transparent pricing gave me confidence to reserve two units. The platform is professional, no-nonsense, and exactly what the market needed.",
      name: "James Chen",
      role: "Property Investor, Wellington",
    },
    {
      id: 3,
      quote: "After my separation, I needed to find a new place without the usual real estate pressure. Beaver let me browse at my own pace, get all my questions answered, and make decisions on my terms. Truly buyer-first.",
      name: "Rebecca Thompson",
      role: "Downsizer, Christchurch",
    },
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((current) => (current + 1) % testimonials.length)
    }, 6000)

    return () => clearInterval(interval)
  }, [testimonials.length])

  return (
    <section className="py-24 bg-neutral-50">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-light text-neutral-900 mb-4">
              Trusted by buyers across New Zealand
            </h2>
            <p className="text-lg text-neutral-600">
              Real stories from people who found their home through Beaver
            </p>
          </div>

          <div className="relative min-h-[320px] md:min-h-[280px]">
            {testimonials.map((testimonial, index) => (
              <TestimonialCard
                key={testimonial.id}
                testimonial={testimonial}
                isActive={index === activeIndex}
              />
            ))}
          </div>

          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === activeIndex
                    ? 'bg-primary-600 w-8'
                    : 'bg-neutral-300 hover:bg-neutral-400'
                }`}
                aria-label={`View testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
